var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVodomerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.9,8.3v0.6H20c0,0-0.2,0-0.9,0c-1.2-2.8-3.7-4.6-6.9-4.6c-3.2,0-5.9,1.8-7.1,4.6c-0.5,0-1.1,0-1.1,0H1.1 V8.3H0v7.4h1.1v-0.6H4c0,0,0.6,0,1.1,0c1.2,2.7,4,4.6,7.1,4.6c3.2,0,5.6-1.9,6.9-4.6c0.6,0,0.9,0,0.9,0h2.9v0.6H24V8.3H22.9z  M12.1,18.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.6,2.8,6.6,6.3C18.7,15.5,15.6,18.3,12.1,18.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 14.7,
    className: "st0",
    width: 7.1,
    height: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "8.7,13.3 8.7,13.9 15.8,13.9 15.8,13.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 8.7,
    className: "st0",
    width: 7.1,
    height: 2.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodomerIcon);
export default __webpack_public_path__ + "static/media/vodomer_icon.2b6b4ca1.svg";
export { ForwardRef as ReactComponent };